import { render } from "./AddDetails.vue?vue&type=template&id=406d9bbd&scoped=true"
import script from "./AddDetails.vue?vue&type=script&lang=js"
export * from "./AddDetails.vue?vue&type=script&lang=js"

import "./AddDetails.vue?vue&type=style&index=0&id=406d9bbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406d9bbd"]])

export default __exports__